import SectionHeading from '@/components/feature/SectionHeading';
import { characters } from '@/mocks/home';

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Characters"
          title="人物关系：每个人都在算自己的账"
          desc="六个关键角色，撑起了整部剧的博弈结构，他们的动机决定了每一次反转的方向。"
        />

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {characters.map((c) => (
            <article key={c.name} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <div className="w-full h-52 md:h-64 overflow-hidden">
                <img src={c.avatar} alt={`${c.name} 角色形象`} className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{c.name}</h3>
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[11px] font-label">
                    {c.role}
                  </span>
                </div>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}